import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map, Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment.local';
import { FollowableUsers } from '../models/like.model';
import { PaginableUsersHttpResult } from '../models/users.model';

@Injectable({
  providedIn: 'root',
})
export class FollowApi {
  constructor(private readonly http: HttpClient) { }

  followUser(userId: string): Observable<any> {
    const url = environment.api.dashboard.followUser.replace('{user}', '' + userId);
    return this.http.post<never>(url, null);
  }

  unFollowUser(userId: string): Observable<any> {
    const url = environment.api.dashboard.followUser.replace('{user}', '' + userId);
    return this.http.delete<any>(url);
  }

  getRecommendedFollows(limit = 5): Observable<FollowableUsers> {
    const params = new HttpParams().set('limit', '' + limit);
    return this.http.get<any>(environment.api.dashboard.recommendedFollows, { params }).pipe(
      map(({ data }) => data)
    );
  }

  getMyFollowers(page: number, limit: number = 15) {
    const params = new HttpParams()
      .set('page', '' + page)
      .set('limit', '' + limit);
    return this.http.get<PaginableUsersHttpResult>(environment.api.dashboard.followers, { params });
  }

  getFollowers(page: number, limit: number, userId: number) {
    const params = new HttpParams()
      .set('page', '' + page)
      .set('limit', '' + limit);
    return this.http.get<PaginableUsersHttpResult>(environment.api.externalUser.followers.replace('{userId}', '' + userId), { params });
  }

  getMyFollowings(page: number, limit: number = 15) {
    const params = new HttpParams()
      .set('page', '' + page)
      .set('limit', '' + limit);
    return this.http.get<PaginableUsersHttpResult>(environment.api.dashboard.followings, { params });
  }

  getFollowings(page: number, limit: number, userId: number) {
    const params = new HttpParams()
      .set('page', '' + page)
      .set('limit', '' + limit);
    return this.http.get<PaginableUsersHttpResult>(environment.api.externalUser.followings.replace('{userId}', '' + userId), { params });
  }

}
